export default __webpack_public_path__ + "static/media/37t.5e56747f.jpg";